<template>
  <div>
    <p class="innerTitle toCapitalize f_medium">{{locale.flightinfo_searchairport}}</p>
    <select class="input" v-model="searchDistance">
        <option v-for="distance in distances()"
          :key="distance"
          :value="distance">
          {{`${distance}km`}}
        </option>
    </select>
  </div>
</template>

<script>
export default {
  props: [
    'locale'
  ],
  computed: {
    searchDistance: {
      get () {
        return this.$store.state.flightinfo.setting.search
      },
      set (distance) {
        this.$store.commit('flightinfo/setSearchDistance', distance)
        this.$store.dispatch('flightinfo/getAirport', distance)
      }
    }
  },
  methods: {
    distances () {
      const distance = function () {
        let arr = []
        for (let i = 1; i <= 10; i++) {
          arr.push(50 * i)
        }
        return arr
      }
      return distance()
    }
  }
}
</script>
